import { render, staticRenderFns } from "./PeachManagement.vue?vue&type=template&id=0ae6ff8e"
import script from "./PeachManagement.vue?vue&type=script&lang=js"
export * from "./PeachManagement.vue?vue&type=script&lang=js"
import style0 from "./PeachManagement.vue?vue&type=style&index=0&id=0ae6ff8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports